<script setup lang="ts">
import { computed } from 'vue';
import { router } from '@/app/router';
import { useDeveloperStore } from '@/app/stores/developer';
import { useUiStore } from '@/app/stores/ui';
// biome-ignore lint/correctness/noUnusedImports: used via tag <UiOverlayLoading> in <template>
import { UiOverlayLoading } from '@/ui-kit';
// biome-ignore lint/correctness/noUnusedImports: used via tag <KioskIdlePopup> in <template>
import KioskIdlePopup from './KioskIdlePopup.vue';
// biome-ignore lint/correctness/noUnusedImports: used via tag <KioskOverlayError> in <template>
import KioskOverlayError from './KioskOverlayError.vue';
// biome-ignore lint/correctness/noUnusedImports: used via tag <KioskOverlayLanguageSelector> in <template>
import KioskOverlayLanguageSelector from './KioskOverlayLanguageSelector.vue';
// biome-ignore lint/correctness/noUnusedImports: used via tag <KioskPrivacyPolicy> in <template>
import KioskPrivacyPolicy from './KioskPrivacyPolicy.vue';

// biome-ignore lint/correctness/noUnusedVariables: used in <template>
const developer = useDeveloperStore();
const ui = useUiStore();

// biome-ignore lint/correctness/noUnusedVariables: used in <template>
const isOnStepPage = computed(() => Boolean(router.step));

// biome-ignore lint/correctness/noUnusedVariables: used in <template>
function closePrivacyPolicy(): void {
  ui.showPrivacyPolicyPopup = false;
}
</script>

<template>
  <UiOverlayLoading v-if="ui.isLoading"/>
  <KioskOverlayError v-if="ui.isError"/>
  <KioskOverlayLanguageSelector v-if="ui.isLanguageSelectorOpen"/>

  <!-- Never show idle popup on Home screen (home has no step, just slug) -->
  <KioskIdlePopup
    v-if="ui.isIdlePopupOpen && !developer.hideIdlePopup && isOnStepPage"
  />
  <!-- KioskPrivacyPolicy is suppressed while the idle popup is open to
       prevent two modal popups from stacking on the kiosk screen, which
       would trap the user (no way to dismiss the one underneath). -->
  <KioskPrivacyPolicy
    v-if="ui.showPrivacyPolicyPopup && !ui.isIdlePopupOpen"
    @close="closePrivacyPolicy"
  />
</template>
